export default __webpack_public_path__ + "static/media/web3image.ce64cdea.png";